import { TradeType } from '@donaswap/sdk'
import { SmartRouterTrade } from '@donaswap/smart-router/evm'
import { useMemo } from 'react'
import { useUserSlippage } from '@donaswap/utils/user'
import { computeSlippageAdjustedAmounts } from '../utils/exchange'

export function useSlippageAdjustedAmounts(trade?: SmartRouterTrade<TradeType>) {
  const [allowedSlippage] = useUserSlippage()
  return useMemo(() => computeSlippageAdjustedAmounts(trade, allowedSlippage), [allowedSlippage, trade])
}
